import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["children", "className", "activeTab"];
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { O2TabsContext } from "./o2-tabs-context";

var O2TabsContent = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(O2TabsContent, _PureComponent);

  function O2TabsContent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeTab: _this.props.activeTab
    });

    return _this;
  }

  O2TabsContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }

    return null;
  };

  var _proto = O2TabsContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        activeTab = _this$props.activeTab,
        attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return /*#__PURE__*/React.createElement(O2TabsContext.Provider, {
      value: {
        activeTabId: this.state.activeTab
      }
    }, /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
      className: className
    }), children));
  };

  return O2TabsContent;
}(PureComponent);

O2TabsContent.propTypes = {
  className: PropTypes.string,
  activeTab: PropTypes.any
};
export default O2TabsContent;